import { template as template_9cc6421d6f354d309823a521372f9b72 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_9cc6421d6f354d309823a521372f9b72(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
